import { enumPreference } from './preferences'

export const THEMES = ['light', 'dark', 'system'] as const
export type Theme = (typeof THEMES)[number]

export const themePreference = enumPreference<Theme>('theme', THEMES, 'system')

/** "system" leaves the choice to prefers-color-scheme (see tokens.css). */
export function applyTheme(theme: Theme): void {
  const root = document.documentElement
  if (theme === 'system') root.removeAttribute('data-theme')
  else root.setAttribute('data-theme', theme)
}

export function startThemeSync(): () => void {
  applyTheme(themePreference.get())
  return themePreference.subscribe(() => applyTheme(themePreference.get()))
}
